import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';

export default function Venue() {
  const { t } = useLanguage();

  return (
    <section id="venue" className="py-24 lg:py-32 px-4 bg-brand-light overflow-hidden">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="w-full lg:w-1/2 relative"
          >
            <div className="aspect-[4/5] relative z-10 overflow-hidden rounded-sm shadow-2xl">
              <img
                src="https://i0.wp.com/jyoshankar.com/wp-content/uploads/2019/07/Jyoshankar_colombia_travelbuide_cartagena_bestphotospots_wheretoeat_whattodo_thingstodo_bestphotospots_travelblogger_40.jpg"
                alt="Colonial Architecture in Cartagena"
                className="w-full h-full object-cover transition-transform duration-700 hover:scale-110"
              />
              <div className="absolute inset-0 bg-brand-dark/10" />
            </div>
            {/* Decorative frame */}
            <div className="absolute -top-6 -left-6 w-32 h-32 border-l-2 border-t-2 border-brand-accent/30 z-0" />
            <div className="absolute -bottom-6 -right-6 w-32 h-32 border-r-2 border-b-2 border-brand-accent/30 z-0" />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="w-full lg:w-1/2"
          >
            <span className="text-brand-accent text-xs uppercase tracking-[0.4em] font-bold mb-4 block">
              {t('venue.label')}
            </span>
            <h2 className="font-serif text-4xl md:text-5xl text-brand-dark mb-6 tracking-tight">
              {t('venue.title')}
            </h2>
            <div className="w-12 h-[1px] bg-brand-accent mb-8" />
            
            <div className="space-y-6">
              <div className="bg-white/50 backdrop-blur-sm p-8 border border-brand-muted/30 rounded-sm">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-10 h-10 rounded-full bg-brand-accent/10 flex items-center justify-center text-brand-accent">
                    <SafeIcon name="Clock" className="text-lg" />
                  </div>
                  <h3 className="font-serif text-xl text-brand-dark">{t('venue.status')}</h3>
                </div>
                <p className="text-brand-dark/70 leading-relaxed font-light mb-6">
                  {t('venue.desc')}
                </p>
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-muted/20 border border-brand-muted/40 rounded-full">
                  <div className="w-2 h-2 bg-brand-accent rounded-full animate-pulse" />
                  <span className="text-[10px] uppercase tracking-widest text-brand-dark/60 font-bold">
                    {t('venue.announcement')}
                  </span>
                </div>
              </div>
              
              <p className="text-brand-dark/60 italic text-sm">
                "{t('venue.quote')}"
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}